import ReferralInfo from './referral-info/model';
import Binnacle from './binnacle/model';
import Documents from './documents/model';
import Signature from './signature/model';

const models = Object.freeze({
  ReferralInfo,
  Binnacle,
  Documents,
  Signature,
});

export default models;
